import { render } from "./AidansMod.vue?vue&type=template&id=6125d461&scoped=true"
import script from "./AidansMod.vue?vue&type=script&lang=js"
export * from "./AidansMod.vue?vue&type=script&lang=js"

import "./AidansMod.vue?vue&type=style&index=0&id=6125d461&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6125d461"]])

export default __exports__